import {
  Button,
  Checkbox,
  Divider,
  Input,
  message,
  Modal,
  Popconfirm,
  Space,
  Spin,
  Tooltip,
  Typography,
  Select,
  Form,
  Alert,
  DatePicker
} from "antd";
import React, { useEffect, useState } from "react";
import {
  CloseOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  SendOutlined,
  FormOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  MedicineBoxOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  HomeOutlined,
  FileTextOutlined,
  LinkOutlined,
  IdcardOutlined,
  GlobalOutlined,
  TagsOutlined,
} from "@ant-design/icons";
import "./ClinicCalenderModal.css";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";
import dayjs from "dayjs";
import { Config } from "../Common/Config";
import axios from "axios";
import { ColorCode } from "../Common/ColorCode";
import { capitalizeFirst } from "../Common/CommonFunction";
import { spacerData } from "./CommonApiCallCalender";
import generateSessionEventPush, {
  pushTraceLogEvent,
} from "./sessionEventPush";
import { parse, format, isBefore, startOfDay } from "date-fns";
const { Option } = Select;

function ClinicCalenderModal(props) {
  // console.log('::::::propsClinicCalenderModal :::::::', props)
  const [form] = Form.useForm();
  const appointmentData =
    props.calenderData &&
      props.calenderData.clinic_id &&
      props.data &&
      props.data.allClinicDataByID &&
      props.data.allClinicDataByID[props.calenderData.clinic_id]
      ? props.data.allClinicDataByID[props.calenderData.clinic_id]
      : props.calenderData.clinic_id;
  const appointmentDataActual = props.calenderData;
  const [modal1Open, setModal1Open] = useState(props.modalStatus);
  const [editAdditionalNote, seteditAdditionalNote] = useState(false);
  const [editAdditionalNoteNew, seteditAdditionalNoteNew] = useState(false);
  const [rescheduleAppointment, setrescheduleAppointment] = useState({
    status: false,
    showButton: true,
  });
  const [isAppointmentEdit, setIsAppointmentEdit] = useState(false);
  const [drapdownData, setdrapdownData] = useState();
  const [selectRoom, setselectRoom] = useState(null);
  const [slotList, setslotList] = useState([]);
  const [roomloading, setRoomloading] = useState(false);
  const [slotloading, setSlotloading] = useState(false);
  const [isCancelled, setisCancelled] = useState(false);
  const [isCancelledChargesApplied, setisCancelledChargesApplied] =
    useState(false);
  const [editAdditionalNoteData, seteditAdditionalNoteData] = useState(null);
  const [AdditionalCategorydata, setAdditionalCategorydata] = useState({
    getAllHealthScreenDataById: null,
    allGPproduct: null,
  });
  const [newStartTime, setNewStartTime] = useState(null);
  const [newSelectedDate, setnewSelectedDate] = useState(appointmentDataActual?.start_time.split(" ")[0]);
  const [pickerDate, setPickerDate] = useState(
    appointmentDataActual?.start_time
      ? dayjs(appointmentDataActual.start_time.split(" ")[0], 'YYYY-MM-DD')
      : null
  );
  const [dateInputValue, setDateInputValue] = useState(
    appointmentDataActual?.start_time
      ? dayjs(appointmentDataActual.start_time.split(" ")[0], 'YYYY-MM-DD').format('DD/MM/YYYY')
      : ""
  );
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [dateInputError, setDateInputError] = useState("");
  const [isChargesOverRide, setisChargesOverRidea] = useState(false);
  const [isAdditionalChargesOverridden, setisAdditionalChargesOverridden] = useState(false);
  const [isCompletedAppointmentChange, setisCompletedAppointmentChange] = useState(false);
  const [roomError, setRoomError] = useState("");
  const [slotError, setSlotError] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const isRescheduledAppointment =
    appointmentDataActual?.is_rescheduled === true ||
    appointmentDataActual?.is_rescheduled === "true" ||
    appointmentDataActual?.is_rescheduled === 1 ||
    appointmentDataActual?.is_rescheduled === "1";
  // final_amount/discount_applied are set at original-booking time and are
  // never recalculated by the reschedule endpoint (only a new
  // AppointmentReschedule row is created) — for a rescheduled appointment,
  // what was actually paid is the rescheduling_charge (+ any
  // additional_charges for an upgraded slot/band), not final_amount.
  const rescheduledPaidAmount =
    parseFloat(appointmentDataActual?.rescheduling_charge || 0) +
    parseFloat(appointmentDataActual?.additional_charges || 0);
  // console.log('::::::appointmentDataActual :::::::', appointmentDataActual)
  useEffect(() => {
    setModal1Open(props.modalStatus);
    seteditAdditionalNoteData(
      appointmentDataActual.additional_notes
        ? appointmentDataActual.additional_notes
        : "",
    );
    if (props && props.getAllHealthScreenData) {
      let getAllHealthScreenDataById = {},
        allGPproduct = {};
      if (
        props.getAllHealthScreenData &&
        props.getAllHealthScreenData.getAllHealthScreenData &&
        props.getAllHealthScreenData.getAllHealthScreenData.data &&
        props.getAllHealthScreenData.getAllHealthScreenData.data.length
      ) {
        props.getAllHealthScreenData.getAllHealthScreenData.data.map((data) => {
          getAllHealthScreenDataById[data.non_gp_product_id] = data;
        });
      }
      if (
        props.getAllHealthScreenData &&
        props.getAllHealthScreenData.allGPproduct &&
        props.getAllHealthScreenData.allGPproduct &&
        props.getAllHealthScreenData.allGPproduct.length
      ) {
        props.getAllHealthScreenData.allGPproduct.map((data) => {
          allGPproduct[data.gp_product_id] = data;
        });
      }
      setAdditionalCategorydata({ getAllHealthScreenDataById, allGPproduct });
    }
  }, [props]);

  const onClose = (data) => {
    props.onClose(false);
    setModal1Open(false);
  };
  const onSubmit = () => {
    props.onClose();
    setModal1Open(false);
  };
  const formatTimeRange = (start_time, end_time) => {
    if (!start_time || !end_time) return "";
    const start = moment(start_time, "YYYY-MM-DD HH:mm:ss.SSS");
    const end = moment(end_time, "YYYY-MM-DD HH:mm:ss.SSS");
    return `${start.format("h:mm A")} - ${end.format("h:mm A")}`;
  };
  const cancelAppointment = async () => {
    const now = moment();
    const inputDate = moment(props.calenderData.start_time);
    if (inputDate < now) {
      // console.log("The date is in the past or now");
      messageApi.error({
        type: "error",
        content: "Past appointment can't be cancelled.",
      });
      return;
    }
    if (!editAdditionalNote) {
      seteditAdditionalNote(true);
      setrescheduleAppointment((pre) => ({ ...pre, status: false }));
    }
    if (
      editAdditionalNote &&
      editAdditionalNoteData &&
      props.calenderData &&
      props.calenderData.appointment_id
    ) {
      generateSessionEventPush({
        module: "Cancelling",
        log_name: "cancel_journey",
        event: "cancel_initiated",
        payload: {
          step: "Cancel Initiated",
          record_id: props.calenderData.appointment_id,
          data: props.calenderData,
        },
        step_status: "success",
      });
      let responcedata = await deleteAppointment(
        props.calenderData.appointment_id,
        editAdditionalNoteData,
      );
      // console.log(':responcedata:::', responcedata)
      if (responcedata?.data?.success) {
        messageApi.success({
          type: "success",
          content: "Appointment has been cancelled successfully.",
        });
        pushTraceLogEvent({
          event: "appointment_cancelled",
          payload: {
            step: "Appointment Cancelled",
            record_id: props.calenderData.appointment_id,
            session_id: localStorage.getItem("session_id") || null,
            data: props.calenderData,
            is_last_step: true,
          },
          step_status: "success",
        });
        setisCancelled(true);
        seteditAdditionalNote(false);
        setisCancelledChargesApplied(true);
        props.onSubmit({ type: "CANCEL", data: "CANCEL" });
      } else {
        messageApi.error({
          type: "error",
          content:
            responcedata?.response?.data?.message ?? "Something went wrong",
        });
      }
    } else {
      if (editAdditionalNote && !editAdditionalNoteData) {
        messageApi.error({
          type: "error",
          content: "Additional notes is required.",
        });
      }
      if (editAdditionalNote && !props.calenderData.appointment_id) {
        messageApi.error({
          type: "error",
          content: "Appointment id not found.",
        });
      }
    }
  };
  const addaddionalNoteInAppointment = async (note, id) => {
    // console.log('addaddionalNoteInAppointment called with id:', id, note);
    if (!note || !id) {
      return messageApi.error({
        type: "error",
        content: "id not found or note is empty",
      });
    }
    let payload = {
      id: id,
      additional_note: note,
    };

    // console.log('props.calenderData ::', props.calenderData, payload)
    // return
    // https://api.ldcbe.webdezign.uk/api/admin/v1/update-additional-note
    // https://api.ldcbe.webdezign.uk/api/admin/v1/update-additional-note/326
    let url = `${Config.url}update-additional-note`;
    try {
      const response = await axios.put(url, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response) {
        messageApi.success({
          type: "succes",
          content: "Appointment note added successfully",
        });
        props.onSubmit({ type: "CANCEL", data: "CANCEL" });
        setModal1Open(false);
      }
    } catch (error) {
      // console.log('Appointment:', error.response?.data || error.message);
      messageApi.error({
        type: "error",
        content: error.message || "Something went wrong",
      });
      throw error;
    }
  };
  const updateAppointmentDetails = async () => {
    const existingOverride = appointmentDataActual?.is_override_charges === "1";
    const dateOnly = newSelectedDate ? newSelectedDate : appointmentDataActual?.start_time.split(" ")[0];
    const time = format(
      parse(
        props.calenderData.start_time,
        "yyyy-MM-dd HH:mm:ss.SSS",
        new Date(),
      ),
      "HH:mm",
    );
    const payload = {
      appointment_id: props.calenderData.appointment_id,
      date: dateOnly,
      clinic_id: props.calenderData.clinic_id,
      start_time: newStartTime ?? time,
      room_id: selectRoom ?? props.calenderData.room_id,
      assigned_room_id: appointmentDataActual?.room_id,
      session_id: localStorage.getItem("trace_log_id"),
      complete_appointment_change:
        typeof isCompletedAppointmentChange === "boolean"
          ? isCompletedAppointmentChange
          : isCompletedAppointmentChange,
    };
    try {
      let url = `${Config.url}update-appointment`;
      const response = await axios.post(url, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response?.data?.success) {
        // console.log("response.data.message",response.data.message)
        messageApi.success({
          type: "success",
          content: response.data.message || "Updated successfully",
        });
        // message.success(response.data.message);
        pushTraceLogEvent({
          event: "Appointment updated successfully",
          payload: {
            appointment_id: appointmentDataActual?.appointment_id,
            start_time: newStartTime || time,
            room_id: selectRoom || props.calenderData.room_id,
            clinic_id: props.calenderData.clinic_id,
          },
          step_status: "success",
        });
        localStorage.removeItem("trace_log_id");
        // Notify parent component and close after a delay to show message
        setTimeout(() => {
          props.onSubmit({ type: "UPDATE", data: "UPDATE" });
          onClose(false);
        }, 1500);
      } else {
        messageApi.error({
          type: "error",
          content: response.data.message,
        });
        pushTraceLogEvent({
          event: "Appointment updated failed",
          payload: {
            appointment_id: appointmentDataActual?.appointment_id,
            start_time: newStartTime || time,
            room_id: selectRoom || props.calenderData.room_id,
            message: response.data.message,
          },
          step_status: "failed",
        });
        onClose(false);
      }
    } catch (error) {
      console.error(error?.message);
      messageApi.error({
        type: "error",
        content: error?.response?.data?.message || "Error updating appointment",
      });
      onClose(false);
    }
  };
  const deleteAppointment = async (id, note) => {
    return new Promise(async (resolve, reject) => {
      const session_id = localStorage.getItem("trace_log_id");
      let payload = {
        delete_note: note,
        override_charges: 0,
        session_id: session_id,
      };
      if (isChargesOverRide) {
        payload = {
          ...payload,
          override_charges: 1,
          cancellation_charges: 0,
        };
      }
      // console.log('props.calenderData ::', props.calenderData, payload)
      // return
      let url = `${Config.url}appointments/${id}`;
      try {
        const response = await axios.delete(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: payload,
        });
        resolve(response);
        if (response) {
          messageApi.success({
            type: "succes",
            content: "Appointment cancelled successfully",
          });
        }
      } catch (error) {
        console.log("Appointment:", error.response?.data || error.message);
        resolve(error);
        // messageApi.error({
        //     type: 'error',
        //     content: error.message || 'Something went wrong',
        // });
        // throw error;
      }
    });
  };
  // ── Date Input helpers (same pattern as DOB in Patientdetails.js) ──
  const formatDateString = (input, isDeleting = false) => {
    if (!input) return "";
    let cleaned = input.replace(/\D/g, "");
    if (cleaned.length > 8) cleaned = cleaned.slice(0, 8);
    if (cleaned.length > 4) return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4)}`;
    if (cleaned.length === 4) return isDeleting ? `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}` : `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/`;
    if (cleaned.length > 2) return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
    if (cleaned.length === 2) return isDeleting ? cleaned : `${cleaned}/`;
    return cleaned;
  };

  const isValidDateStr = (dateString) => {
    if (!dateString) return false;
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) return false;
    const [day, month, year] = dateString.split("/").map(Number);
    if (year < 1900 || year > new Date().getFullYear() + 5) return false;
    if (month < 1 || month > 12) return false;
    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) monthLength[1] = 29;
    return day > 0 && day <= monthLength[month - 1];
  };

  const handleDateInputChange = (e) => {
    const isDeleting = e.nativeEvent && e.nativeEvent.inputType === "deleteContentBackward";
    const formatted = formatDateString(e.target.value, isDeleting);
    setDateInputValue(formatted);
    if (!isValidDateStr(formatted)) {
      setDateInputError("Please enter a valid date in DD/MM/YYYY format");
    } else {
      setDateInputError("");
      const date = dayjs(formatted, 'DD/MM/YYYY');
      onDateChange(date, formatted);
    }
  };

  const handleDateInputBlur = () => {
    if (dateInputValue) {
      const parts = dateInputValue.split("/");
      const day = parts[0]?.padStart(2, "0") || "";
      const month = parts[1]?.padStart(2, "0") || "";
      const year = parts[2] || "";
      const formatted = `${day}${day ? "/" : ""}${month}${month && year ? "/" : ""}${year}`;
      if (formatted !== dateInputValue) setDateInputValue(formatted);
    }
    // Delay so a calendar-cell click fires handleCalendarPickAppt before the popup closes
    setTimeout(() => setIsDatePickerOpen(false), 200);
  };

  const handleCalendarPickAppt = (date) => {
    if (date) {
      const formatted = date.format("DD/MM/YYYY");
      setDateInputValue(formatted);
      setDateInputError("");
      onDateChange(date, formatted);
    }
    setIsDatePickerOpen(false);
  };

  const onDateChange = async (date, dateString) => {
    // console.log("onDateChange", date, dateString);
    // Update picker display value FIRST (synchronous) so it doesn't snap back
    setPickerDate(date);
    setselectRoom(null);
    setNewStartTime(null);
    setslotList([]);
    setRoomError("");
    setSlotError("");
    form.setFieldsValue({ room_id: null, start_time: null });
    if (!date) return;
    const dateOnly = moment(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD');
    setnewSelectedDate(dateOnly);
    setRoomloading(true);
    let data = {
      date: dateOnly,
      clinic_id: appointmentDataActual?.clinic_id,
      appointment_id: appointmentDataActual?.appointment_id,
      assigned_room_id: appointmentDataActual?.room_id,
      complete_appointment_change: false,
    };
    // console.log("data", data);
    let rooms = await getRooms(data);
    setRoomloading(false);
    if (rooms === false || !rooms?.data || rooms.data.length === 0) {
      setdrapdownData([]);
      if (!isCompletedAppointmentChange) {
        setRoomError(
          `No rooms available${appointmentDataActual?.product_name ? ` for ${appointmentDataActual.product_name}` : ''}.`
        );
      }
    } else {
      setdrapdownData(rooms?.data);
      setRoomError("");
    }
    if (isCompletedAppointmentChange) {
      setSlotloading(true);
      // console.log("newSelectedDate",newSelectedDate)
      let slotData = {
        appointment_id: appointmentDataActual?.appointment_id,
        date: dateOnly,
        clinic_id: appointmentDataActual?.clinic_id,
        assigned_room_id: appointmentDataActual?.room_id,
        complete_appointment_change: true,
      };
      getTimeslot(slotData, (hasSlots) => {
        if (!hasSlots) {
          setSlotError(
            `No slots available${appointmentDataActual?.product_name ? ` for ${appointmentDataActual.product_name}` : ''}.`
          );
        } else {
          setSlotError("");
        }
      });
    }
  };
  const disabledDate = (current) => {
    // Disable past dates (before today)
    return current && current.isBefore(dayjs().startOf('day'));
  };

  const rescheduleAppointmentFunction = async (id) => {
    // console.log(
    //   "rescheduleAppointmentFunction called with id:",
    //   props.calenderData,
    // );
    // return
    const now = moment();
    const inputDate = moment(props.calenderData.start_time);
    if (inputDate < now) {
      // console.log("The date is in the past or now");
      messageApi.error({
        type: "error",
        content: "Past appointment can't be reschedule.",
      });
      return;
    }
    if (!rescheduleAppointment.status) {
      pushTraceLogEvent({
        event: "reschedule_button_clicked",
        payload: {
          step: "Reschedule button clicked - stage 1",
          record_id: props.calenderData?.appointment_id,
        },
        step_status: "success",
      });
      setrescheduleAppointment((pre) => ({ ...pre, status: true }));
    }
    // props.calenderData.language_id = 2
    // console.log('props::calenderData language_id::', props.calenderData.language_id)
    // return
    if (rescheduleAppointment.status) {
      console.log(
        "rescheduleAppointmentFunction called with id:",
        props.calenderData,
      );
      // return
      // Derive the category type from localStorage product-category list (dynamic, supports new types)
      const _storedCategories = (() => {
        try {
          const parsed = JSON.parse(localStorage.getItem('showCategory') || '{}');
          const result = Array.isArray(parsed) ? parsed : Object.values(parsed);
          return Array.isArray(result) ? result : [];
        } catch (e) { return []; }
      })();
      const _apptCat = Array.isArray(_storedCategories)
        ? _storedCategories.find(c =>
          c.product_category_id == props.calenderData.product_category_id
        )
        : undefined;
      const _reschedCatType = _apptCat?.type || (
        props.calenderData.product_category_id == 1 ? 'gp' :
          props.calenderData.product_category_id == 3 ? 'corporate' : 'd2c'
      );
      let datanew = {
        clinic: {
          productCategory: {
            key: _reschedCatType,
            type: _reschedCatType,
            title:
              props.calenderData.product_category_name ||
              (_reschedCatType === 'gp' ? 'GP appointments' :
                _reschedCatType === 'corporate' ? 'Corporate appointments' :
                  'Health screens'),
            name:
              props.calenderData.product_category_name ||
              (_reschedCatType === 'gp' ? 'GP appointments' :
                _reschedCatType === 'corporate' ? 'Corporate appointments' :
                  'Health screens'),
            product_category_id: props.calenderData.product_category_id
              ? props.calenderData.product_category_id
              : 1,
            description: "one-liner description",
            non_gp_product_id: props.calenderData.product_id
              ? props.calenderData.product_id
              : null,
          },
          non_gp_product_id: props.calenderData.product_id
            ? props.calenderData.product_id
            : null,
          productData: props.calenderData.product_name
            ? { name: props.calenderData.product_name }
            : null,
          isChargesOverRide:
            props.calenderData.rescheduling_charge == 0
              ? true
              : isChargesOverRide,
          isAdditionalChargesOverridden: isAdditionalChargesOverridden,
          isReshedula: true,
          calenderData: props.calenderData,
        },
        duration: props.calenderData.duration_id,
        gender:
          props.calenderData.preferred_gender &&
            props.calenderData.preferred_gender == "no_preference"
            ? "no_preference"
            : props.calenderData.preferred_gender == "male"
              ? "male"
              : "female",
        language: props.calenderData.language_id,
        type: "PreferredTime",
        data: props.calenderData,
      };
      generateSessionEventPush({
        module: "Rescheduling",
        log_name: "reschedule_journey",
        event: "reschedule_initiated",
        payload: {
          step: "Reschedule Initiated",
          record_id: props.calenderData.appointment_id,
          data: props.calenderData,
        },
        step_status: "success",
      });
      console.log("datanew:::", datanew);
      props.onSubmit({ type: "RESCHEDULE", data: datanew });
      setModal1Open(false);
    }
  };
  const gobackFunction = () => {
    seteditAdditionalNote(false);
    setrescheduleAppointment((pre) => ({ ...pre, status: false }));
  };
  const editAppointment = async () => {
    const startDateTime = parse(
      props.calenderData.start_time,
      "yyyy-MM-dd HH:mm:ss.SSS",
      new Date(),
    );
    const appointmentDate = startOfDay(startDateTime);
    const today = startOfDay(new Date());
    const isPastEvent = isBefore(appointmentDate, today);
    // if (isPastEvent) {
    //   messageApi.error({
    //     type: "error",
    //     content: "Past appointment can't be edited.",
    //   });
    //   return;
    // }
    // console.log("editAppointment:::", appointmentDataActual);
    setIsAppointmentEdit(true);
    setRoomloading(true);
    const dateOnly = appointmentDataActual?.start_time.split(" ")[0];
    let data = {
      date: dateOnly,
      clinic_id: appointmentDataActual?.clinic_id,
      appointment_id: appointmentDataActual?.appointment_id,
      assigned_room_id: appointmentDataActual?.room_id,
      complete_appointment_change: false,
    };
    let rooms = await getRooms(data);
    if (rooms?.data === false) {
    } else {
      setdrapdownData(rooms?.data);
    }
    setRoomloading(false);
    generateSessionEventPush({
      event: "Appointment Update started",
      payload: {
        appointment_id: appointmentDataActual?.appointment_id,
        date: new Date().toLocaleDateString().split("T")[0],
      },
      module: "Appointment Update",
      log_name: "Appointment update",
    });
  };
  const handleRoomSelect = async (room) => {
    setslotList([]);
    setSlotError("");
    setSlotloading(true);
    const dateOnly = newSelectedDate ? newSelectedDate : appointmentDataActual?.start_time.split(" ")[0];
    let data = {
      appointment_id: appointmentDataActual?.appointment_id,
      date: dateOnly,
      clinic_id: appointmentDataActual?.clinic_id,
      room_id: room,
      assigned_room_id: appointmentDataActual?.room_id,
    };
    getTimeslot(data, (hasSlots) => {
      if (!hasSlots) {
        setSlotError(
          `No slots available${appointmentDataActual?.product_name ? ` for ${appointmentDataActual.product_name}` : ''}.`
        );
      } else {
        setSlotError("");
      }
    });
    setselectRoom(room);
  };
  const handleStartTimeChange = (selectedSlot) => {
    setNewStartTime(selectedSlot);
  };
  const onChangeCompleteAppointment = (e) => {
    // console.log(`checked = ${e.target.checked}`);
    if (e.target.checked) {
      setSlotloading(true);
      setSlotError("");
      const dateOnly = newSelectedDate ? newSelectedDate : appointmentDataActual?.start_time.split(" ")[0];
      // console.log("newSelectedDate",newSelectedDate)
      let data = {
        appointment_id: appointmentDataActual?.appointment_id,
        date: dateOnly,
        clinic_id: appointmentDataActual?.clinic_id,
        assigned_room_id: appointmentDataActual?.room_id,
        complete_appointment_change: true,
      };
      getTimeslot(data, (hasSlots) => {
        if (!hasSlots) {
          setSlotError(
            `No slots available${appointmentDataActual?.product_name ? ` for ${appointmentDataActual.product_name}` : ''}.`
          );
        } else {
          setSlotError("");
        }
      });
    } else {
      setslotList([]);
      setSlotError("");
    }
    setisCompletedAppointmentChange(e.target.checked)
  }
  const getTimeslot = async (payload, onComplete) => {
    let url = `${Config.url}get-appointment-slots`;
    try {
      const response = await axios.post(url, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response) {
        setSlotloading(false);
        const slots = response?.data?.data?.slots || [];
        setslotList(slots);
        if (onComplete) onComplete(slots.length > 0);
      }
    } catch (error) {
      setSlotloading(false);
      console.log('Appointment Error:', error.response?.data || error.message);

      // Extract detailed validation errors if available
      let errorMessage = error.response?.data?.message || error.message || "Something went wrong";
      if (error.response?.data?.errors) {
        const validationErrors = Object.values(error.response.data.errors)
          .flat()
          .join(', ');
        errorMessage = validationErrors || errorMessage;
      }

      messageApi.error({
        type: "error",
        content: errorMessage,
      });
      if (onComplete) onComplete(false);
    }
  };
  const getRooms = async (payload) => {
    return new Promise(async (resolve, reject) => {
      let url = `${Config.url}get-filtered-rooms`;
      try {
        const response = await axios.post(url, payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response) {
          // setSlotloading(false);
          // let newData = response?.data;
          // setslotList(response?.data?.data.slots);
          // setSlotloading(false);
          resolve(response?.data);
          // setModal1Open(false);
        }
      } catch (error) {
        // setSlotloading(false);
        console.log('Appointment Error:', error.response?.data || error.message);
        // Extract detailed validation errors if available
        let errorMessage = error.response?.data?.message || error.message || "Something went wrong";
        if (error.response?.data?.errors) {
          const validationErrors = Object.values(error.response.data.errors)
            .flat()
            .join(', ');
          errorMessage = validationErrors || errorMessage;
        }
        messageApi.error({
          type: "error",
          content: errorMessage,
        });
        resolve(false);
      }
    });
  };
  // Derive category type for UI display
  const _storedCategories = (() => {
    try {
      const parsed = JSON.parse(localStorage.getItem('showCategory') || '{}');
      const result = Array.isArray(parsed) ? parsed : Object.values(parsed);
      return Array.isArray(result) ? result : [];
    } catch (e) { return []; }
  })();
  const _uiApptCat = Array.isArray(_storedCategories)
    ? _storedCategories.find(c =>
      c.product_category_id == appointmentDataActual?.product_category_id
    )
    : undefined;
  const _uiCatType = _uiApptCat?.type || (
    appointmentDataActual?.product_category_id == 1 ? 'gp' :
      appointmentDataActual?.product_category_id == 3 ? 'corporate' : 'd2c'
  );

  // console.log('rescheduleAppointment:::', appointmentDataActual)
  const _specialPricingBand = appointmentDataActual?.special_pricing_band;
  const _specialPrice = parseFloat(_specialPricingBand?.special_price);
  const _originalCharges = parseFloat(appointmentDataActual?.charges);
  const hasRealPricingDiscount = !!_specialPricingBand
    && Number.isFinite(_specialPrice)
    && Number.isFinite(_originalCharges)
    && _specialPrice < _originalCharges;
  return (
    <div>
      {contextHolder}
      <Modal
        title={<span style={{ color: "white" }}>Appointment details:</span>}
        open={props.modalStatus}
        onOk={() => onSubmit(false)}
        onCancel={() => onClose(false)}
        footer={null}
        mask={false}
        // getContainer={false}
        className="custom-appointment-modal"
        style={{ position: "absolute", right: 0, top: 100 }}
        closeIcon={
          <CloseOutlined
            style={{ color: "red", fontSize: "18px", marginTop: "-10px" }}
          /> // Change color here
        }
      >
        <Spin
          className="custom-spinner"
          spinning={roomloading || slotloading}
          tip={roomloading ? "Fetching rooms..." : "Fetching slots..."}
          style={{ maxHeight: 'none' }}
        >
          {appointmentDataActual?.appt_source != "2" && (
            <div
              style={{
                marginLeft: 36,
                marginRight: 36,
                marginTop: 0,
                marginBottom: 10,
                justifySelf: "end",
                display: isAppointmentEdit ? "none" : "flex",
              }}
            >
              <Tooltip title="Edit appointment">
                <FormOutlined className="appt-edit-icon" onClick={editAppointment} />
              </Tooltip>
            </div>
          )
          }
          <div className="appt-info-row">
            <EnvironmentOutlined className="appt-icon" />
            <span className="appt-value appt-clinic-name">
              {appointmentData && appointmentData.name
                ? appointmentData.name
                : "Canary Wharf"}
            </span>
          </div>
          <div className="appt-info-row">
            <CalendarOutlined className="appt-icon" />
            <span className="appt-value">
              {appointmentDataActual && appointmentDataActual.start_time
                ? moment(
                  appointmentDataActual.start_time,
                  "YYYY-MM-DD HH:mm:ss.SSS",
                ).format("dddd, Do MMMM, YYYY")
                : "Monday, 8th January, 2025"}
            </span>
          </div>
          <div className="appt-info-row">
            <ClockCircleOutlined className="appt-icon" />
            <span className="appt-value">
              <span className="appt-time-badge">
                {appointmentDataActual.start_time && appointmentDataActual.end_time
                  ? formatTimeRange(
                    appointmentDataActual.start_time,
                    appointmentDataActual.end_time,
                  )
                  : "8:30 - 9:00"}
              </span>
            </span>
          </div>
          <div className="appt-info-row">
            <MedicineBoxOutlined className="appt-icon" />
            <span className="appt-value">
              <span className="appt-product-name">
                {/* Show category/product name for all types; show price for all types when charges present */}
                {_uiCatType === 'gp'
                  ? "GP appointments:"
                  : (appointmentDataActual?.product_name
                    ?? AdditionalCategorydata.getAllHealthScreenDataById?.[
                      appointmentDataActual?.product_id
                    ]?.name
                    ?? appointmentDataActual?.product_category_name
                    ?? "") + ":"}
              </span>
              {appointmentDataActual.charges
                ? <span className="appt-price-value">
                  {hasRealPricingDiscount ? (
                    <>
                      <span style={{ textDecoration: 'line-through', opacity: 0.7, fontSize: 12, marginRight: 4 }}>
                        £{parseFloat(appointmentDataActual.charges).toFixed(2)}
                      </span>
                      £{parseFloat(appointmentDataActual.special_pricing_band.special_price).toFixed(2)}
                    </>
                  ) : (
                    <>£{parseFloat(appointmentDataActual.charges).toFixed(2)}</>
                  )}
                </span>
                : null}{" "}
            </span>
          </div>
          {(appointmentDataActual?.discount_applied || hasRealPricingDiscount || isRescheduledAppointment) ? (
            <div className="appt-financial-box">
              {hasRealPricingDiscount && (
                <div className="appt-financial-row" style={{ marginBottom: 6 }}>
                  <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 5,
                    background: appointmentDataActual.special_pricing_band.colour || "#E85D04",
                    color: "#fff",
                    borderRadius: 20,
                    padding: "3px 10px",
                    fontSize: 12,
                    fontWeight: 600,
                  }}>
                    <TagsOutlined /> {appointmentDataActual.special_pricing_band.band_name}
                  </span>
                </div>
              )}
              {hasRealPricingDiscount ? (
                <>
                  <div className="appt-financial-row">
                    <span className="appt-financial-label">Original Price:</span>
                    <span className="appt-financial-amount" style={{ color: '#999', textDecoration: 'line-through' }}>
                      &pound;{Number(appointmentDataActual.charges).toFixed(2)}
                    </span>
                  </div>
                  <div className="appt-financial-row">
                    <span className="appt-financial-label">Discounted Price:</span>
                    <span className="appt-financial-amount" style={{ color: appointmentDataActual.special_pricing_band.colour || '#E85D04', fontWeight: 600 }}>
                      &pound;{Number(appointmentDataActual.special_pricing_band.special_price).toFixed(2)}
                    </span>
                  </div>
                </>
              ) : null}
              {/* Coupon discounts are a new-booking concept — don't surface a
                  stale original-booking coupon discount against a
                  rescheduled appointment's current financial summary. */}
              {appointmentDataActual?.discount_applied && !isRescheduledAppointment ? (
                <div className="appt-financial-row">
                  <span className="appt-financial-label">Discount:</span>
                  <span className="appt-financial-amount">
                    &pound;{Number(appointmentDataActual.discount_applied).toFixed(2)}
                  </span>
                </div>
              ) : null}
              {hasRealPricingDiscount && (
                <div className="appt-financial-row">
                  <span className="appt-financial-label" style={{ color: '#008385' }}>You Save:</span>
                  <span className="appt-financial-amount" style={{ color: '#008385', fontWeight: 500 }}>
                    &pound;{(
                      (parseFloat(appointmentDataActual.charges) - parseFloat(appointmentDataActual.special_pricing_band.special_price))
                      + (!isRescheduledAppointment && appointmentDataActual?.discount_applied ? parseFloat(appointmentDataActual.discount_applied) : 0)
                    ).toFixed(2)}
                  </span>
                </div>
              )}
              <div className="appt-financial-row">
                <span className="appt-financial-label">{isRescheduledAppointment ? "Total paid:" : "Amount paid:"}</span>
                <span className="appt-financial-amount">
                  &pound;{Number(isRescheduledAppointment ? rescheduledPaidAmount : appointmentDataActual.final_amount).toFixed(2)}
                </span>
              </div>
            </div>
          ) : ''}
          {appointmentDataActual.patient &&
            appointmentDataActual.patient?.appointment_reason &&
            AdditionalCategorydata.allGPproduct &&
            AdditionalCategorydata.allGPproduct[
            appointmentDataActual.patient?.appointment_reason
            ] ? (
            <div className="appt-info-row">
              <FileTextOutlined className="appt-icon" />
              <span className="appt-value">
                {AdditionalCategorydata.allGPproduct[
                  appointmentDataActual.patient?.appointment_reason
                ].name ?? ""}{" "}
              </span>
            </div>
          ) : null}
          {/* Clinician Gender — separate row */}
          {appointmentDataActual?.preferred_gender && (
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 8, fontSize: 14, color: '#333' }}>
              <span style={{ fontWeight: 600, color: '#555' }}>Clinician Gender: </span>
              {capitalizeFirst(appointmentDataActual.preferred_gender.replace(/_/g, ' '))}
            </p>
          )}
          {/* Language — separate row */}
          {appointmentDataActual?.language_name && (
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10, fontSize: 14, color: '#333' }}>
              <span style={{ fontWeight: 600, color: '#555' }}>Language: </span>
              {appointmentDataActual.language_name}
            </p>
          )}
          <div className="appt-info-row">
            <UserOutlined className="appt-icon" />
            <span className="appt-value">
              {appointmentDataActual &&
                appointmentDataActual.patient &&
                appointmentDataActual.patient.first_name
                ? appointmentDataActual.patient.first_name +
                " " +
                (appointmentDataActual.patient.last_name ?? "")
                : ""}
              {appointmentDataActual?.cardholder_name
                ? <span style={{ color: '#888', fontSize: 12, marginLeft: 8 }}>
                  (Cardholder: {appointmentDataActual.cardholder_name})
                </span>
                : ""}
            </span>
          </div>
          {appointmentDataActual.patient?.email && (
            <div className="appt-info-row">
              <MailOutlined className="appt-icon" />
              <span className="appt-value">{appointmentDataActual.patient.email}</span>
            </div>
          )}
          {appointmentDataActual.patient?.mobile_with_code && (
            <div className="appt-info-row">
              <PhoneOutlined className="appt-icon" />
              <span className="appt-value">{appointmentDataActual.patient.mobile_with_code}</span>
            </div>
          )}
          {isRescheduledAppointment && (
            <>
              <span style={{ fontWeight: 700, marginLeft: 36, marginBottom: 10 }}>Original appointment</span>
              <p
                style={{
                  marginLeft: 36,
                  marginRight: 36,
                  marginTop: 0,
                  marginBottom: 0,
                }}
              >
                {_uiCatType === 'gp'
                  ? "GP appointments"
                  : (AdditionalCategorydata.getAllHealthScreenDataById?.[
                    appointmentDataActual?.product_id
                  ]?.name ?? appointmentDataActual?.product_category_name ?? "").replace(" £", ": £")}
                {_uiCatType === 'gp' ? ":" : ""}
                {_uiCatType === 'gp'
                  ? (appointmentDataActual.original_amount
                    ? " £" + Number(appointmentDataActual.original_amount).toFixed(2)
                    : " £0")
                  : ""}{" "}
              </p>
              <p
                style={{
                  marginLeft: 36,
                  marginRight: 36,
                  marginTop: 0,
                  marginBottom: 0,
                }}
              >
                {"Discount:"}
                {appointmentDataActual.discount_applied
                  ? " £" + Number(appointmentDataActual.discount_applied).toFixed(2)
                  : " £0"}{" "}
              </p>
              <p
                style={{
                  marginLeft: 36,
                  marginRight: 36,
                  marginTop: 0,
                  marginBottom: 10,
                }}
              >
                {"Amount paid:"}
                {appointmentDataActual.final_amount
                  ? " £" + Number(appointmentDataActual.final_amount).toFixed(2)
                  : " £0"}{" "}
              </p>
            </>
          )}
          {(appointmentDataActual?.patient?.address_1 ||
            appointmentDataActual?.patient?.address_2 ||
            appointmentDataActual?.patient?.city ||
            appointmentDataActual?.postal_code ||
            appointmentDataActual?.patient?.country) && (
              <div className="appt-info-row appt-address-row">
                <HomeOutlined className="appt-icon" />
                <span className="appt-value">
                  {appointmentDataActual.patient?.address_1 || ""}
                  {appointmentDataActual.patient?.address_2
                    ? ", " + appointmentDataActual.patient.address_2
                    : ""}
                  {appointmentDataActual.patient?.city
                    ? ", " + appointmentDataActual.patient.city
                    : ""}
                  {appointmentDataActual.postal_code
                    ? ", " + appointmentDataActual.postal_code
                    : ""}
                  {appointmentDataActual.patient?.country
                    ? ", " + appointmentDataActual.patient.country
                    : ""}
                </span>
              </div>
            )}
          {appointmentDataActual?.corporate_customer?.name && (
            <div className="appt-info-row">
              <LinkOutlined className="appt-icon" />
              <span className="appt-value">
                <span style={{ fontWeight: 600, color: '#555' }}>Corporate: </span>
                {appointmentDataActual.corporate_customer?.name}
              </span>
            </div>
          )}
          {appointmentDataActual?.patient?.member_number && (
            <div className="appt-info-row">
              <UserOutlined className="appt-icon" />
              <span className="appt-value">
                <span style={{ fontWeight: 600, color: '#555' }}>Vitality No: </span>
                {appointmentDataActual.patient.member_number}
              </span>
            </div>
          )}
          {isAppointmentEdit ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  marginLeft: 36,
                  marginRight: 36,
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                {appointmentDataActual?.clinicians_count &&
                  appointmentDataActual?.clinicians_count >= 2 ? (
                  <Checkbox
                    onChange={onChangeCompleteAppointment}
                  >
                    Complete Appointment
                  </Checkbox>
                ) : (
                  ""
                )}
              </div>
              <Form form={form}>
                <Form.Item
                  label="Date"
                  style={{
                    marginLeft: 36,
                    marginRight: 36,
                    marginTop: 0,
                    marginBottom: 10,
                  }}
                >
                  <div style={{ marginLeft: '30px', width: 185, position: 'relative' }}>
                    {/* Visible Input with DD/MM/YYYY auto-format + calendar icon */}
                    <div style={{
                      display: 'flex', alignItems: 'center',
                      border: dateInputError ? '1px solid #ff4d4f' : '1px solid #d9d9d9',
                      borderRadius: 6, height: 30, paddingLeft: 8, paddingRight: 8,
                      background: '#fff',
                    }}>
                      <Input
                        value={dateInputValue}
                        placeholder="DD/MM/YYYY"
                        autoComplete="off"
                        onKeyDown={(e) => {
                          const allowed = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter', 'Escape', '/'];
                          if (e.ctrlKey || e.metaKey) return;
                          if (!allowed.includes(e.key) && !/^\d$/.test(e.key)) e.preventDefault();
                        }}
                        onChange={handleDateInputChange}
                        onBlur={handleDateInputBlur}
                        style={{ border: 'none', outline: 'none', background: 'transparent', fontSize: 14, boxShadow: 'none', paddingLeft: 0, flex: 1 }}
                        suffix={
                          <CalendarOutlined
                            style={{ color: '#008385', cursor: 'pointer', fontSize: 14 }}
                            onMouseDown={(e) => {
                              // preventDefault stops the input losing focus (which would close the picker)
                              e.preventDefault();
                              setIsDatePickerOpen(true);
                            }}
                          />
                        }
                      />
                    </div>
                    {dateInputError && (
                      <div style={{ color: '#ff4d4f', fontSize: 11, marginTop: 3 }}>{dateInputError}</div>
                    )}
                    {/* Invisible DatePicker — popup only */}
                    <div style={{ position: 'absolute', top: 30, left: 0, opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}>
                      <DatePicker
                        format="DD/MM/YYYY"
                        disabledDate={disabledDate}
                        allowClear={false}
                        open={isDatePickerOpen}
                        onOpenChange={setIsDatePickerOpen}
                        value={dateInputValue && isValidDateStr(dateInputValue) ? dayjs(dateInputValue, 'DD/MM/YYYY') : pickerDate}
                        onChange={handleCalendarPickAppt}
                      />
                    </div>
                  </div>
                </Form.Item>
                {!isCompletedAppointmentChange ? (
                  <>
                    {drapdownData?.length > 0 ? (
                      <Form.Item
                        label="Room"
                        name="room_id"
                        rules={[
                          { required: true, message: "Room selection is required." },
                        ]}
                        style={{
                          marginLeft: 36,
                          marginRight: 36,
                          marginTop: 0,
                          marginBottom: 10,
                        }}
                      >
                        <Select
                          className="inputbox-custom-placeholder"
                          placeholder="Select Room"
                          style={{
                            width: 185,
                            height: 30,
                            textAlign: "center",
                            marginLeft: "24px",
                            color: "#bfbfbf",
                            borderColor: "#bfbfbf"
                          }}
                          onChange={(value) => handleRoomSelect(value)}
                          loading={roomloading}
                          notFoundContent="No rooms available"
                        >
                          {drapdownData?.map((item, index) => (
                            <Option key={index} value={item.room_id}>
                              {item?.room_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    ) : roomError ? (
                      <div style={{ marginLeft: 36, marginRight: 36, marginBottom: 10 }}>
                        <Alert
                          message={roomError}
                          type="error"
                          showIcon
                          style={{ fontSize: 13 }}
                        />
                      </div>
                    ) : null}
                  </>
                ) : null}
                {slotList && slotList.length > 0 ? (
                  <Form.Item
                    label="Start Time"
                    name="start_time"
                    style={{
                      marginLeft: 36,
                      marginRight: 36,
                      marginTop: 0,
                      marginBottom: 10,
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Start Time selection is required.",
                      },
                    ]}
                  >
                    <Select
                      className="inputbox-custom-placeholder"
                      placeholder="Select Start Time"
                      style={{ width: 185, height: 30, textAlign: "center" }}
                      onChange={(value) => handleStartTimeChange(value)}
                      loading={slotloading}
                    >
                      {slotList?.map((item, index) => (
                        <Option key={index} value={item.start_time}>
                          {item.start_time}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                ) : slotError ? (
                  <div style={{ marginLeft: 36, marginRight: 36, marginBottom: 10 }}>
                    <Alert
                      message={slotError}
                      type="error"
                      showIcon
                      style={{ fontSize: 13 }}
                    />
                  </div>
                ) : null}
              </Form>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginLeft: 36,
                  marginRight: 36,
                  marginTop: 20,
                  marginBottom: 0,
                }}
              >
                <Popconfirm
                  title="Confirm Update"
                  className="confirmation-popup"
                  description="Are you sure you want to update the appointment?"
                  onConfirm={updateAppointmentDetails}
                  icon={
                    <QuestionCircleOutlined
                      style={{
                        color: "red",
                      }}
                    />
                  }
                  okButtonProps={{
                    className: "confirmation-popup-ok-button",
                  }}
                  cancelButtonProps={{
                    className: "confirmation-popup-cancel-button",
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    type="primary"
                    style={{
                      width: "130px",
                      height: "30px",
                      backgroundColor: "#008385",
                      color: "#fff",
                    }}
                  >
                    Save
                  </Button>
                </Popconfirm>
                <Button
                  className="add-generic-btn"
                  type="primary"
                  style={{
                    width: "130px",
                    height: "30px",
                    // backgroundColor: "#008385",
                    color: "#fff",
                  }}
                  onClick={() => onClose(false)}
                >
                  Cancel
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="appt-notes-card">
                <span className="appt-notes-label">Notes</span>
                <span className="appt-notes-text">
                  {appointmentDataActual.notes
                    ? appointmentDataActual.notes.replace(/\s*£[\d,]+(?:\.\d{1,2})?$/, '').trim() || "—"
                    : "—"}
                </span>
              </div>
              {appointmentDataActual?.cancellations_rescheduling_restrictions &&
                appointmentDataActual?.cancellations_rescheduling_restrictions ==
                "Yes" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginLeft: 36,
                      marginRight: 36,
                      marginTop: 0,
                      marginBottom: editAdditionalNote ? 10 : 10,
                    }}
                  >
                    <Typography.Text strong>
                      Additional Notes:
                      {appointmentDataActual?.additional_notes ? (
                        <span style={{ fontWeight: "normal" }}>
                          {" "}
                          {appointmentDataActual?.additional_notes}
                        </span>
                      ) : (
                        ""
                      )}
                    </Typography.Text>
                    {appointmentDataActual?.appt_source != "2" && appointmentDataActual?.is_edit_appointment &&
                      editAdditionalNoteNew == false && (
                        <div style={{ marginLeft: "5px" }}>
                          <Tooltip title="Edit additional notes">
                            <EditOutlined
                              className="appt-edit-icon"
                              onClick={() => seteditAdditionalNoteNew(true)}
                            />
                          </Tooltip>
                        </div>
                      )}
                  </div>
                )}
              {appointmentDataActual?.appt_source == "2" ? (
                <div className="appt-info-row" style={{ marginBottom: 10 }}>
                  <LinkOutlined className="appt-icon" />
                  <span className="appt-value">
                    Booking Source: <span className="appt-semble-badge">Semble</span>
                  </span>
                </div>
              ) : (
                ""
              )}

              {editAdditionalNote || editAdditionalNoteNew ? (
                <TextArea
                  value={editAdditionalNoteData}
                  style={{
                    width: 250,
                    height: 40,
                    marginLeft: 36,
                    marginRight: 36,
                    marginTop: 0,
                    marginBottom: 0,
                    whiteSpace: "collapse", // Prevents text wrapping
                    overflow: "inherit", // Hides overflow text
                    textOverflow: "ellipsis", // Adds "..." if text overflows
                    border: "none",
                    borderBottom: "1px solid #000",
                    borderRadius: 0,
                    boxShadow: "none",
                    paddingLeft: 0,
                    backgroundColor: "#F0FAFA",
                  }}
                  placeholder="Additional Notes..."
                  onChange={(e) => seteditAdditionalNoteData(e.target.value)}
                />
              ) : (
                ""
              )}
              {editAdditionalNoteNew && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: 36,
                    marginRight: 36,
                    marginTop: 20,
                    marginBottom: 0,
                  }}
                >
                  <Button
                    className="add-generic-btn"
                    type="primary"
                    style={{
                      width: "130px",
                      height: "30px",
                      backgroundColor: "#008385",
                      color: "#fff",
                    }}
                    onClick={() =>
                      addaddionalNoteInAppointment(
                        editAdditionalNoteData,
                        props.calenderData.appointment_id,
                      )
                    }
                  >
                    Save
                  </Button>
                  <Button
                    className="add-generic-btn"
                    type="primary"
                    style={{
                      width: "130px",
                      height: "30px",
                      backgroundColor: "#008385",
                      color: "#fff",
                    }}
                    onClick={() => seteditAdditionalNoteNew(false)}
                  >
                    Cancel
                  </Button>
                </div>
              )}
              {appointmentDataActual?.payment_mode ? (
                <div className="appt-info-row" style={{ marginBottom: 10, marginTop: editAdditionalNoteNew ? 10 : 0 }}>
                  <Typography.Text strong>
                    Payment Method:
                    <span style={{ fontWeight: "normal" }}>
                      {" "}
                      {appointmentDataActual?.payment_mode}
                    </span>
                  </Typography.Text>
                </div>) : ""
              }
              {(editAdditionalNote || rescheduleAppointment.status) && (
                <div className="appt-override-warning">
                  <Checkbox onChange={(e) => setisChargesOverRidea(e.target.checked)} style={{ marginBottom: '6px' }}>
                    {rescheduleAppointment.status == false
                      ? "Override cancellation charges."
                      : "Override rescheduling charges."}
                  </Checkbox>
                  <Checkbox onChange={(e) => setisAdditionalChargesOverridden(e.target.checked)}>
                    {"Override additional charges."}
                  </Checkbox>
                </div>
              )}
              {/* {rescheduleAppointment.status == true && !isChargesOverRide ? 'Rescheduling charges will be waived.' : isChargesOverRide ? '' : 'Cancellation charges will be waived.'} */}
              {(editAdditionalNote || rescheduleAppointment.status) &&
                isChargesOverRide == false && (
                  <div className="appt-charge-notice">
                    {rescheduleAppointment.status ? "Rescheduling" : "Cancellation"}{" "}
                    charge of &pound;
                    {rescheduleAppointment.status
                      ? appointmentDataActual?.rescheduling_charge
                      : appointmentDataActual?.cancellation_charge}{" "}
                    will apply.
                  </div>
                )}
              {(editAdditionalNote || rescheduleAppointment.status) &&
                isChargesOverRide == true && (
                  <div className="appt-charge-notice">
                    {rescheduleAppointment.status ? "Rescheduling" : "Cancellation"}{" "}
                    charges will be waived
                  </div>
                )}
              {isCancelledChargesApplied && isCancelled ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: 36,
                    marginRight: 36,
                    marginTop: 0,
                    marginBottom: 10,
                  }}
                >
                  {" "}
                  {editAdditionalNoteData ? editAdditionalNoteData : ""}
                </div>
              ) : (
                ""
              )}
              {!isCancelled ? (
                <>
                  <Divider className="appt-divider" style={{ margin: '10px 0', borderColor: '#d0eded' }} />
                  <Space
                    direction="vertical"
                    style={{
                      width: "100%",
                      marginLeft: 36,
                      marginTop: 0,
                      marginTop: 0,
                      marginBottom: 0,
                    }}
                  >
                    {appointmentDataActual?.cancellations_rescheduling_restrictions &&
                      appointmentDataActual?.cancellations_rescheduling_restrictions ==
                      "Yes" &&
                      rescheduleAppointment.showButton && (
                        <>
                          {!editAdditionalNote &&
                            appointmentDataActual?.appt_source != "2" && (
                              <Button
                                className={
                                  rescheduleAppointment ? "" : "add-generic-btn"
                                }
                                type="primary"
                                style={{ width: "266px", height: "30px" }}
                                onClick={rescheduleAppointmentFunction}
                              >
                                {rescheduleAppointment.status
                                  ? "Proceed to reschedule"
                                  : "Reschedule the appointment"}
                              </Button>
                            )}
                          {appointmentDataActual?.cancellations_rescheduling_restrictions &&
                            appointmentDataActual?.cancellations_rescheduling_restrictions ==
                            "Yes" &&
                            rescheduleAppointment.status == false &&
                            appointmentDataActual?.appt_source != "2" &&
                            (editAdditionalNote ? (
                              <Popconfirm
                                title="Delete"
                                className="confirmation-popup"
                                description="Are you sure you want to cancel?"
                                // onConfirm={() => deleteUser(record)}
                                onCancel={cancelAppointment}
                                icon={
                                  <QuestionCircleOutlined
                                    style={{
                                      color: "red",
                                    }}
                                  />
                                }
                                okButtonProps={{
                                  className: "confirmation-popup-ok-button",
                                }}
                                cancelButtonProps={{
                                  className: "confirmation-popup-cancel-button",
                                }}
                                // okText="Yes"
                                // cancelText="No"
                                okText="No"
                                cancelText="Yes"
                              >
                                <Button
                                  type="primary"
                                  style={{
                                    width: "266px",
                                    height: "30px",
                                    backgroundColor: "#008385",
                                    color: "#fff",
                                  }}
                                >
                                  {editAdditionalNote
                                    ? "Proceed to cancel"
                                    : "Cancel the appointment"}
                                </Button>
                              </Popconfirm>
                            ) : (
                              <Button
                                type="primary"
                                style={{
                                  width: "266px",
                                  height: "30px",
                                  backgroundColor: "#008385",
                                  color: "#fff",
                                }}
                                onClick={cancelAppointment}
                              >
                                {editAdditionalNote
                                  ? "Proceed to cancel"
                                  : "Cancel the appointment"}
                              </Button>
                            ))}

                          {(editAdditionalNote || rescheduleAppointment.status) && (
                            <Button
                              className="add-generic-btn"
                              type="primary"
                              style={{
                                width: "266px",
                                height: "30px",
                                backgroundColor: "#008385",
                                color: "#fff",
                              }}
                              onClick={gobackFunction}
                            >
                              Go back
                            </Button>
                          )}
                        </>
                      )}
                  </Space>
                </>
              ) : (
                <Alert
                  type="error"
                  showIcon
                  message="This appointment has been cancelled."
                  style={{ margin: '0 36px 16px 36px', borderRadius: 8 }}
                />
              )}
            </>
          )}
        </Spin>
      </Modal>
    </div>
  );
}

export default ClinicCalenderModal;
